module.exports = __webpack_public_path__ + "html/bodycode-form.component.html";